import React from 'react'
import FooterApi from 'utils/FooterApi'
import BreadcrumbComponent from 'components/Breadcrumbs'
import { MainWrapper, AboutUsWrapper, ContentWrapper } from 'styles/FooterLinks/AboutUsPage'

const ReturnAndRefund = () => {
  const { data } = FooterApi('returnpolicy')
  return (
    <MainWrapper>
      <AboutUsWrapper>
        <BreadcrumbComponent title="Returns & Refunds" />
        <ContentWrapper>
          <div dangerouslySetInnerHTML={{ __html: data?.returnpolicy }} />
        </ContentWrapper>
      </AboutUsWrapper>
    </MainWrapper>
  )
}

export default ReturnAndRefund
